class IngredientsList extends HTMLElement {
  constructor() {
    super();
    this.filters = this.querySelectorAll("[data-filter]");
    this.active_filters = [];
    this.articles = Array.from(this.querySelectorAll("article"));
  }

  connectedCallback() {
    this.filters.forEach((filter) => {
      filter.addEventListener("click", () => {
        this.toggleFilter(filter);
      });
    });
  }

  toggleFilter(filter) {
    const value = filter.getAttribute("data-value");
    if (this.active_filters.includes(value)) {
      this.active_filters = this.active_filters.filter(
        (item) => item !== value,
      );
      filter.removeAttribute("data-active");
    } else {
      this.active_filters.push(value);
      filter.setAttribute("data-active", "");
    }

    this.articles.forEach((article) => {
      if (this.active_filters.length) {
        if (
          this.active_filters.some((filter) =>
            article.getAttribute("data-filters").split(",").includes(filter),
          )
        ) {
          article.removeAttribute("hidden");
          [...article.querySelectorAll("[data-filter]")].forEach((filter) => {
            if (
              this.active_filters.length > 1 &&
              this.active_filters.includes(filter.getAttribute("data-value"))
            ) {
              filter.setAttribute("data-active", "");
            } else {
              filter.removeAttribute("data-active");
            }
          });
        } else {
          article.setAttribute("hidden", "");
        }
      } else {
        article.removeAttribute("hidden");
        article
          .querySelectorAll("[data-filter]")
          .forEach((filter) => filter.removeAttribute("data-active"));
      }
    });
    console.log(this.active_filters);
  }
}

customElements.define("ingredients-list", IngredientsList);
